export default __webpack_public_path__ + "static/media/dreamstime_s_98716328.5abc0108.jpg";